import { windowWidth } from "@styles/global";
import styled from "styled-components";

const ResendEmailConfirmationContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: auto;
`;

const ResendEmailConfirmationFormContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  flex-direction: column;

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 90%;
    padding-left: 0;
    padding-right: 0;
  }
`;

const ResendEmailConfirmationTelluriaGroupContainer = styled.div`
  width: 180px;
  padding-top: 50px;
`;

export {
  ResendEmailConfirmationContainer,
  ResendEmailConfirmationFormContainer,
  ResendEmailConfirmationTelluriaGroupContainer
};
